<template>
   <div class="payment-options">
      <Modal 
         :show="showInstructions" 
         :loading="loading" 
         type="simple" 
         @close="showInstructions = false"
      > 
         <template slot="content">
            <div class="fx-modal-title clearfix">
               <div class="ci ci-info l">
                  <i class="icon" :class="PaymentOption.forms.add_payment_option.icon"></i>
               </div>
               <div class="text l" id="formModalLabel">
                  <div class="fx-h6">View Instructions</div>
                  <div class="text-muted">View Payment Instructions</div>
               </div>
               <button class="close" @click="showInstructions = false" aria-label="Close">
                  <span>&times;</span>
               </button>
            </div>
            <div class="fx-modal-body">
               <div class="instructions" v-html="selectedInstruction"></div>
            </div>
         </template>
      </Modal>

      <Modal 
         :show="show" 
         :loading="loading" 
         :icon="PaymentOption.forms.add_payment_option.icon" 
         :title="PaymentOption.forms.add_payment_option.title" 
         :subtitle="PaymentOption.forms.add_payment_option.subtitle" 
         @close="$store.commit('show',false)"
         @submit="addPaymentOption({ref: $refs[PaymentOption.forms.add_payment_option.name], instruction})"
      >
         <template slot="form">
            <div>
               <Form 
                  classBinding="row" 
                  :ref="PaymentOption.forms.add_payment_option.name" 
                  :forms="PaymentOption.forms.add_payment_option.forms" 
                  :form_data="PaymentOption.forms.add_payment_option.data"
               />
               <editor
                  api-key="no-api-key"
                  :init="{
                     height: 500,
                     menubar: false,
                     plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                     ],
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat | help'
                  }"
                  v-model="instruction"
               />
            </div>
         </template>
      </Modal>

      <Modal 
         :show="showEdit" 
         :loading="loading" 
         :icon="PaymentOption.forms.edit_payment_option.icon" 
         :title="PaymentOption.forms.edit_payment_option.title" 
         :subtitle="PaymentOption.forms.edit_payment_option.subtitle" 
         button="Save"
         @close="$store.commit('showEdit',false)"
         @submit="editPaymentOption({ref: $refs[PaymentOption.forms.edit_payment_option.name],instruction: edit_instruction})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="PaymentOption.forms.edit_payment_option.name" 
               :forms="PaymentOption.forms.edit_payment_option.forms" 
               :formData="PaymentOption.forms.edit_payment_option.data"
            />
            <editor
               api-key="no-api-key"
               :init="{
                  height: 500,
                  menubar: false,
                  plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help'
               }"
               v-model="edit_instruction"
            />
         </template>
      </Modal>

      <Table 
         :icon="PaymentOption.tables.payment_options.icon" 
         :table_fields="PaymentOption.tables.payment_options.table_fields" 
         :table_data="payment_options" 
         :title="PaymentOption.tables.payment_options.title" 
         :search_fields="PaymentOption.tables.payment_options.search_fields"
         :row_data="PaymentOption.tables.payment_options.row_data"
         @on-action="handleActions"
      />
   </div>
</template>

<script>
import payment_option from "../rsc/stores/configs/paymentOption.store";
import Editor from '@tinymce/tinymce-vue'

export default {
   beforeDestroy () {
      this.$store.unregisterModule('payment_option')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('payment_option',payment_option,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: 'Payment Option Actions',
            actions: [
               {
                  title: 'Add Payment Option',
                  icon: 'fa-money-check-alt',
                  event: 'action:add_payment_option',
               },
            ]
         })
      },800);

      EventBus.$on("action:add_payment_option", payload => {
         this.$store.commit('show', true)
      });
      EventBus.$on("action:upload_fuel_payment_option", payload => {
         this.$store.commit('showUpload', true)
      });
   },
   data () {
      return {
         instruction: '',
         edit_instruction: '',
         instructionEdit: '',
         selectedInstruction: '',
         showInstructions: false,
      }
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
      'editor': Editor
   },
   computed: {
      ...mapGetters([
         'PaymentOption',
         'payment_options',
         'show',
         'loading',
         'showEdit',
         'showUpload',
         'selectedPaymentOption',
      ])
   },
   methods: {
      ...mapActions([
         'addPaymentOption',
         'fetchPaymentOptions',
         'fetchFormData',
         'editPaymentOption',
         'deletePaymentOption',
         'uploadStations',
      ]),
      async handleActions(payload){
         if(payload.action === 'payment_option:view'){
            this.selectedInstruction = payload.row.instructions
            this.showInstructions = true
         }else if(payload.action === 'payment_option:delete'){
            await this.deletePaymentOption(payload.row._id)
         }else if(payload.action === 'payment_option:edit'){
            this.edit_instruction = payload.row.instructions
            let Model = this.PaymentOption
            Model.forms.edit_payment_option.data = payload.row
            this.$store.commit('PaymentOption',Model)
            this.$store.commit('selectedPaymentOption',payload.row)
            this.$store.commit('showEdit',true)
         }
      },
   },
   async mounted(){
      utils.registerModule('payment_option',payment_option,this.$store)
      await this.fetchPaymentOptions()
   }
}
</script>

<style lang="scss">
   .payment-options{
      .instructions{
         font-size: 16px;
      }
   }
</style>